import React from 'react'
import styled from 'styled-components'
import { giphyLightCharcoal } from '../styles/colors'

const RenditionInfo = styled.div`
    margin: 0px 0 10px;
    color: ${giphyLightCharcoal};
`
const RenditionTitle = styled.span`
    font-weight: bold;
`

const RenditionSize = styled.span`
    float: right;
`

const RenditionExampleContainer = styled.div`
    flex-grow: ${props => (props.video ? '1' : '0')};
`

const RenditionExample = ({ image, title, filesize, video }) => {
    const isVideo = video
    let exampleContent

    if (!isVideo) {
        exampleContent = <img src={image} />
    } else {
        exampleContent = (
            <video autoPlay loop width="100%">
                <source src={video} type="video/mp4" />
            </video>
        )
    }

    return (
        <RenditionExampleContainer video={video}>
            {exampleContent}
            <RenditionInfo>
                <RenditionTitle>{title}</RenditionTitle>
                <RenditionSize>{filesize}</RenditionSize>
            </RenditionInfo>
        </RenditionExampleContainer>
    )
}

export default RenditionExample
